import { useMemo, useState } from 'react';
import cs from 'classnames';
import { isNotEmpty, isNotEmptyAny } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import CircleTaskDetailMap from 'src/common/components/business/ExpandStore/CircleTaskDetailMap/index';
import { isHighlightEmergencyDegree } from 'src/common/components/business/ExpandStore/ts-config';
import AreaDetailDrawer from '@/common/components/business/AreaDetailDrawer';
import styles from './index.module.less';
import { Col, Row } from 'antd';
import V2Title from '@/common/components/Feedback/V2Title';

/** 拓店任务详情项名称映射表 */
const TaskMap = {
  modelClusterName: '商圈',
  targetAdress: '目标城市',
  manager: '开发人员',
  followingStatusName: '跟进状态',
  emergencyDegreeName: '紧急度',
  // assignAccountIds: '拓店任务责任人',
};

/**
 * 拓店任务：森马（参考clusterA直营）-详情-基本信息-带商圈
 * @description
 * 拓店任务：直营-详情
 */
const CircleBasicInfo = (props: {
  taskDetail:any;
  chancePointList?: any;
  /** 支持查看详情 */
  hideClusterDetail?: boolean;
  /** 是否作为机会点详情内任务模块 */
  isChanceDetailModule?: boolean;
  title?: string;
  className?: string;
}) => {

  const { taskDetail, chancePointList, hideClusterDetail, isChanceDetailModule, title, className } = props;
  // 选址地图详情抽屉
  const [drawerData, setDrawerData] = useState<{ open: boolean, id: string }>({
    open: false,
    id: ''
  });

  const basicTaskInfo = useMemo(() => {
    if (!isNotEmptyAny(taskDetail)) return {};
    const { modelClusterInfo, manager, followingStatusName, emergencyDegreeName, targetProvinceName, targetCityName, targetDistrictName, assignAccountIds } = taskDetail;
    return {
      modelClusterName: modelClusterInfo?.modelClusterName,
      targetAdress: [targetProvinceName !== targetCityName ? targetProvinceName : '', targetCityName, targetDistrictName].filter(item => isNotEmpty(item)).join('/'),
      manager,
      followingStatusName,
      emergencyDegreeName,
      assignAccountIds,
    };
  }, [taskDetail]);

  const methods = useMethods({

    /**
     * @description 点击商圈名称
     */
    handleClickClusterName: () => {
      const modelClusterId = taskDetail?.modelClusterInfo?.modelClusterId;
      if (!modelClusterId) return;
      setDrawerData({
        open: true,
        id: modelClusterId
      });
    },

    /**
     * @description 是否红色高亮
     * @param key 字段名
     * @return 高紧急度时返回true
     */
    isRedColorValue(key: string) {
      return key === 'emergencyDegreeName' && isHighlightEmergencyDegree(taskDetail.emergencyDegree);
    }
  });

  return <div className={cs(styles.basicWrapper, className || '')}>
    <div className={styles.basicInfo}>
      {isChanceDetailModule ? <V2Title
        type='H2'
        divider
        text={title}
        className={'pt-16 pb-10'}
      /> : <></>}
      <div className={cs(styles.basicMap)}>
        <CircleTaskDetailMap businessDetail={taskDetail} chancePointList={chancePointList} />
      </div>
      <Row gutter={24}>
        {
          Object.entries(TaskMap).map(([key, label], index) => {
            return <Col span={8} key={index}>
              <div className={styles.label}>{label}</div>
              <div className={styles.value}>
                {(key === 'modelClusterName' && !hideClusterDetail)
                  ? <a className={'color-primary-dark'} onClick={methods.handleClickClusterName}>{basicTaskInfo[key] || '-'}</a>
                  : (
                    methods.isRedColorValue(key)
                      ? <span style={{ color: 'red' }}>{(basicTaskInfo[key] || '-')}</span>
                      : (basicTaskInfo[key] || '-')
                  )}
              </div>
            </Col>;
          })
        }
      </Row>
    </div>
    {/* <div className={cs(styles.basicMap)}>
    </div> */}
    <AreaDetailDrawer drawerData={drawerData} setDrawerData={setDrawerData} viewChanceDetail={false} showCollect={false} />
  </div>;
};

export default CircleBasicInfo;
